import { Box, Skeleton } from '@mui/material'
import React from 'react'

function LoadingUserPage() {
    return (
        <Box
            sx={{
                backgroundColor: '#fff',
                borderRadius: '16px',
                boxShadow: '0 4px 16px rgba(12,61,110,0.07)',
                padding: '20px 22px',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <Skeleton
                    animation="wave"
                    variant="circular"
                    height={42}
                    width={42}
                    sx={{ backgroundColor: 'rgba(34, 93, 153, 0.08)' }}
                />
                <Skeleton
                    animation="wave"
                    variant="rounded"
                    height={16}
                    width={140}
                    sx={{ borderRadius: '6px', backgroundColor: 'rgba(34, 93, 153, 0.08)' }}
                />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <Skeleton
                    animation="wave"
                    variant="circular"
                    height={16}
                    width={16}
                    sx={{ backgroundColor: 'rgba(34, 93, 153, 0.06)' }}
                />
                <Skeleton
                    animation="wave"
                    variant="rounded"
                    height={12}
                    width={180}
                    sx={{ borderRadius: '4px', backgroundColor: 'rgba(34, 93, 153, 0.06)' }}
                />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
                <Skeleton
                    animation="wave"
                    variant="circular"
                    height={16}
                    width={16}
                    sx={{ backgroundColor: 'rgba(34, 93, 153, 0.06)' }}
                />
                <Skeleton
                    animation="wave"
                    variant="rounded"
                    height={12}
                    width={180}
                    sx={{ borderRadius: '4px', backgroundColor: 'rgba(34, 93, 153, 0.06)' }}
                />
            </Box>

            <Skeleton
                animation="wave"
                variant="rounded"
                height={24}
                width={70}
                sx={{ borderRadius: '20px', backgroundColor: 'rgba(217, 108, 60, 0.1)' }}
            />
        </Box>
    )
}

export default LoadingUserPage